<style lang="scss" scoped>
.checkbox {
    width: 16px;
    height: 16px;
    cursor: pointer;
    border: 2px solid #ccc;
    border-radius: 4px;
    transition: border 0.15s ease-in-out, background 0.15s ease-in-out;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        border-color: var(--accent);
        background: var(--accent-light);
    }
    &.active {
        background: var(--accent);
        border-color: var(--accent);
        .checkmark {
            width: 4px;
            height: 8px;
            border-bottom: 1px solid #fff;
            border-right: 1px solid #fff;
            transform: rotate(45deg);
            margin-top: -2px;
            pointer-events: none;
        }
    }
}
</style>

<template>
    <div class="checkbox" :key="_uid" :class="{ active: localValue }" @click="localValue = !localValue; update()">
        <span v-if="localValue" class="checkmark"></span>
    </div>
</template>
<script>

import isInput from './is-input';

export default {
    name: "el-checkbox",

    mixins: [isInput],
}
</script>